const E = 1.77777, T = {
  sm: 185,
  md: 215,
  lg: 215,
  xl: 245
};
export {
  E as DEFAULT_ASPECT_RATIO,
  T as JUSTIFIED_GALLERY_DEFAULT_HEIGHTS
};
